export interface ISurroundings {
  position: Array<number>;
  distance: number;
  title: string;
  averageRating: number;
  category: {
    id: string;
    title: string;
    href: string;
    type: string;
    system: string;
  };
  icon: string;
  vicinity: string;
  having: Array<any>;
  type: string;
  href: string;
  tags: Array<{
    id: string;
    title: string;
    group: string;
  }>;
  id: string;
  openingHours: {
    text: string;
    label: string;
    isOpen: boolean;
    structured: Array<{
      start: string;
      duration: string;
      recurrence: string;
    }>;
  };
  alternativeNames: Array<{
    name: string;
    language: string;
  }>;
}

export enum SurroundingsIcon {
  '100-1000' = 'restaurant',
  '100-1100' = 'cafe',
  '200-2000' = 'bar',
  '200-2200' = 'theatre',
  '300-3000' = 'sightseeing',
  '300-3100' = 'museum'
}

export interface Surroundings {
  title: string;
  id: string;
  icon: string;
  language: string;
  position: {
    lat: string;
    lng: string;
  };
  distance: number;
  categories: Array<{
    id: string;
    name: string;
    primary?: boolean;
  }>;
}
